import { mainRouteNames } from './routeNames/mainRouteNames'
import { organizationRouteNames, organizerRouteNames } from './routeNames/organizerRouteNames'
import { sharedRouteNames } from './routeNames/sharedRouteNames'
import {
  theaterOrganizationRouteNames,
  theaterOrganizerRouteNames,
} from './routeNames/theaterOrganizerRouterNames'
import { ticketSellerAdminRouteNames } from './routeNames/ticketSellerAdminRouteNames'
import { ticketSellerRouteNames } from './routeNames/ticketSellerRouteNames'
import { ungroupedRouteNames } from './routeNames/ungroupedRouteNames'
import { adminRouteNames } from '@/routing/routeNames/adminRouteNames'
import {
  sportOrganizationRouteNames,
  sportOrganizerRouteNames,
} from '@/routing/routeNames/sportOrganizerRouteNames'

/**
 * Model for user types
 *
 * This is used for checking route access permission in middleware and redirecting
 * in utils.routing.js
 */
export const routingUserModelTypes = {
  ticketSeller: {
    names: ['TICKET_SELLER'],
    allowedRoutes: Object.values({
      ...ticketSellerRouteNames,
      ...sharedRouteNames,
      ...ungroupedRouteNames,
    }),
    startingRoute: mainRouteNames.ticketSellerSidebar,
  },
  ticketSellerAdmin: {
    names: ['TICKET_SELLER_ADMIN'],
    allowedRoutes: Object.values({
      ...ticketSellerAdminRouteNames,
      ...sharedRouteNames,
      ...ungroupedRouteNames,
    }),
    startingRoute: ticketSellerAdminRouteNames.reportsAdmin,
  },
  organizer: {
    names: ['TRIAL', 'REGULAR', 'SUPER_ADMIN'],
    allowedRoutes: Object.values({
      ...mainRouteNames,
      ...organizationRouteNames,
      ...theaterOrganizationRouteNames,
      ...theaterOrganizerRouteNames,
      ...sportOrganizationRouteNames,
      ...sportOrganizerRouteNames,
      ...organizerRouteNames,
      ...sharedRouteNames,
      ...ungroupedRouteNames,
      ...adminRouteNames,
    }),
    startingRoute: organizerRouteNames.organizations,
  },
}
